import { getBrightnessFromHexColor } from 'swag-common/utils/colors';
import { GIVEAWAY_LANDING_FALLBACK_COLOR } from 'swag-common/constants/giveaway.constants';
const NOT_READABLE_BRIGHTNESS_THRESHOLD = 252;
export const getIsGiveawayColorTooBright = giveawayColorHex => getBrightnessFromHexColor(giveawayColorHex) >= NOT_READABLE_BRIGHTNESS_THRESHOLD;
export const getGiveawayColorWithFallback = giveawayColorHex => {
  const isColorTooBright = getIsGiveawayColorTooBright(giveawayColorHex);
  return !giveawayColorHex || isColorTooBright ? GIVEAWAY_LANDING_FALLBACK_COLOR : giveawayColorHex;
};